import {Form, Input, Modal, Spin} from 'antd';
import PropTypes from 'prop-types';
import {useEffect} from 'react';
import toast from 'react-hot-toast';
import {useSelector} from 'react-redux';

import {RqAddDeliveryCharges, RqUpdateliveryCharges} from '../../../../reactQuery/apis';
import {selectAuth} from '../../../../redux/selectors';

const DeliveryChargesModal = ({open, onCancel, refetch, updateRecord}) => {
  const [form] = Form.useForm();

  const auth = useSelector(selectAuth);
  
  const token = auth?.tokenData;

  const {mutate: addDeliveryCharges, isLoading} = RqAddDeliveryCharges({
    onSuccess: () => {
      toast.success('Delivery charge added successfully');
      refetch();
      form.resetFields();
      onCancel();
    },
    onError: error => {
      toast.error(error?.response?.data?.message || 'Failed to add');
    },
  });

  const {mutate: updateDeliveryCharges} = RqUpdateliveryCharges({
    onSuccess: () => {
      toast.success('Delivery charge updated successfully');
      refetch();
      form.resetFields();
      onCancel();
    },
    onError: error => {
      toast.error(error?.response?.data?.message || 'Update failed');
    },
  });

  useEffect(() => {
    if (updateRecord) {
      form.setFieldsValue({
        state: updateRecord.state,
        deliveryDays: updateRecord.deliveryDays,
        charges: updateRecord.charges,
      });
    } else {
      form.resetFields();
    }
  }, [updateRecord, form]);

  const handleFinish = values => {
    const formattedData = {
      state: Array.isArray(values.state) ? values.state : [values.state],
      charges: values.charges,
      deliveryDays: values.deliveryDays,
    };

    if (updateRecord) {
      updateDeliveryCharges({
        token,
        id: updateRecord.id,
        formData: formattedData,
      });
    } else {
      addDeliveryCharges({
        token,
        formData: formattedData,
      });
    }
  };

  if (isLoading) {
    return (
      <div className={'flex justify-center items-center'}>
        <Spin size={'large'} />
      </div>
    );
  }

  return (
    <Modal
      title={updateRecord ? 'Update Delivery Charge' : 'Add Delivery Charge'}
      open={open}
      width={600}
      onCancel={() => {
        form.resetFields();
        onCancel();
      }}
      onOk={() => form.submit()}
      centered
      okText={updateRecord ? 'Update' : 'Save'}
      cancelText={'Cancel'}
      okButtonProps={{
        className: '!bg-primary-900 !text-white hover:!bg-primary-800',
      }}
    >
      <Form
        form={form}
        layout={'vertical'}
        onFinish={handleFinish}
        className={'flex flex-col gap-3'}
      >
        <Form.Item
          label={'State'}
          name={'state'}
          rules={[{required: true, message: 'Please enter state name'}]}
        >
          <Input placeholder={'Enter state'} />
        </Form.Item>

        <Form.Item
          label={'Delivery Days'}
          name={'deliveryDays'}
          rules={[{required: true, message: 'Please enter delivery days'}]}
        >
          <Input placeholder={'e.g., 3-5 Days'} />
        </Form.Item>

        <Form.Item
          label={'Charges (₹)'}
          name={'charges'}
          rules={[{required: true, message: 'Please enter charges amount'}]}
        >
          <Input type={'number'} placeholder={'Enter charges'} min={0} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

DeliveryChargesModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  refetch: PropTypes.func,
  updateRecord: PropTypes.object,
};

export default DeliveryChargesModal;
